import { defineComponent as h, h as o } from "vue";
import i from "./ghl-ui.es1337.js";
import { toHexaString as d, toHexString as s, toHslaString as c, toHslString as m, toRgbaString as U, toRgbString as f, toHsvaString as g, toHsvString as A } from "./ghl-ui.es904.js";
import y from "./ghl-ui.es183.js";
const x = h({
  name: "ColorInput",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    mode: {
      type: String,
      required: !0
    },
    modes: {
      type: Array,
      required: !0
    },
    showAlpha: {
      type: Boolean,
      required: !0
    },
    value: {
      // for hex to get percise value
      type: String,
      default: null
    },
    valueArr: {
      type: Array,
      default: null
    },
    onUpdateValue: {
      type: Function,
      required: !0
    },
    onUpdateMode: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    return {
      handleUnitUpdateValue(a, l) {
        const {
          showAlpha: r
        } = e;
        if (e.mode === "hex") {
          e.onUpdateValue((r ? d : s)(l));
          return;
        }
        let t;
        switch (e.valueArr === null ? t = [0, 0, 0, 0] : t = Array.from(e.valueArr), e.mode) {
          case "hsv":
            t[a] = l, e.onUpdateValue((r ? g : A)(t));
            break;
          case "rgb":
            t[a] = l, e.onUpdateValue((r ? U : f)(t));
            break;
          case "hsl":
            t[a] = l, e.onUpdateValue((r ? c : m)(t));
            break;
        }
      }
    };
  },
  render() {
    const {
      clsPrefix: e,
      modes: a
    } = this;
    return o("div", {
      class: `${e}-color-picker-input`
    }, o("div", {
      class: `${e}-color-picker-input__mode`,
      onClick: this.onUpdateMode,
      style: {
        cursor: a.length === 1 ? "" : "pointer"
      }
    }, this.mode.toUpperCase() + (this.showAlpha ? "A" : "")), o(y, null, {
      default: () => {
        const {
          mode: l,
          valueArr: r,
          showAlpha: t
        } = this;
        if (l === "hex") {
          let u = null;
          try {
            u = r === null ? null : (t ? d : s)(r);
          } catch {
          }
          return o(i, {
            label: "HEX",
            showAlpha: t,
            value: u,
            onUpdateValue: (n) => {
              this.handleUnitUpdateValue(0, n);
            }
          });
        }
        return (l + (t ? "a" : "")).split("").map((u, n) => o(i, {
          label: u.toUpperCase(),
          value: r === null ? null : r[n],
          onUpdateValue: (p) => {
            this.handleUnitUpdateValue(n, p);
          }
        }));
      }
    }));
  }
});
export {
  x as default
};
